import { useCallback } from "react";
import { useLineAuth } from "@utils/store/auth/useLineAuth";
import { useUser } from "@utils/store/user/useUser";
import { appToast } from "@components/Toast";
import { saveVerifiedPhoneToAccount } from "./api/saveVerifiedPhone";

const digits = (p?: string | null) => (p || "").replace(/\D/g, "");

/**
 * 結算頁 OtpCard 驗證成功後：驗的號碼跟帳號手機不同 → 寫回帳號（驗證哪支就是帳號手機）。
 * 失敗不擋這張單（號碼本身已通過驗證、可以聯絡），只提示帳號手機維持原號碼。
 */
export function useWriteBackVerifiedPhone(
  onSaved?: (phone: string) => void,
  /** 寫回失敗時呼叫；回傳 true 表示呼叫端已自行提示，不再 toast。 */
  onFailed?: (r: { kind: string; message: string }) => boolean | void,
) {
  const { lineAccessToken } = useLineAuth();
  const setUserData = useUser((st) => st.setUserData);
  return useCallback(
    async (phone: string, ticket: string) => {
      if (!lineAccessToken || !ticket) return;
      // userData 一律呼叫當下現讀（同 CheckoutPhoneSetup）：這個 callback 是在 OTP 驗證的非同步回應裡被呼叫，
      // render 時的快照可能已過期，拿舊資料去比對或 spread 會蓋掉期間更新過的欄位。
      if (digits(phone) === digits(useUser.getState().userData?.phone)) return;
      const res = await saveVerifiedPhoneToAccount({ accessToken: lineAccessToken, phone: digits(phone), phoneVerifiedTicket: ticket });
      if (res.ok) {
        setUserData({ ...(useUser.getState().userData || {}), phone: res.phone });
        onSaved?.(res.phone);
        return;
      }
      if (onFailed?.({ kind: res.kind, message: res.message }) === true) return;
      appToast.error(`${res.message}，帳號手機維持原號碼`);
    },
    [lineAccessToken, setUserData, onSaved, onFailed],
  );
}
